import { useMutation, useQueryClient } from '@tanstack/react-query';

import { addProgramFollow } from '@/modules/library/domain/resources/addProgramFollow';
import { deleteProgramFollow } from '@/modules/library/domain/resources/deleteProgramFollow';
import { useNotifications } from '@/modules/notifications/hooks/useNotifications';
import { useProgram } from '@/modules/programs/hooks/useProgram';

import { useProgramFollows } from './useProgramFollows';

export const useToggleProgramFollow = (programUUID: string) => {
  const queryClient = useQueryClient();
  const { showNotificationInfo, showNotificationError } = useNotifications();

  const { program } = useProgram(programUUID as string);

  const { programsFollowed, isLoading } = useProgramFollows();

  const programFollowed = programsFollowed?.find(({ programId }) => programId === programUUID);
  const isProgramFollowed = Boolean(programFollowed);

  const { mutate: toggleFollow } = useMutation({
    mutationKey: ['follow', programUUID],
    mutationFn: () =>
      isProgramFollowed
        ? deleteProgramFollow(programFollowed?.id)
        : addProgramFollow(program.source, programUUID),

    onSuccess: () => {
      queryClient.refetchQueries(['follow']);
      if (!isProgramFollowed) {
        showNotificationInfo('notifications.following.add.title');
      }
    },
    onError: () => {
      showNotificationError();
    },
  });

  return {
    isProgramFollowed,
    programsFollowed,
    isLoadingPlaylist: isLoading,
    toggleFollow,
  };
};
